import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

/**
 * Signup Redirect Service
 * Handles redirection to PFWA (Post-Form Web Application) after signup completion
 * Creates and submits a hidden form to securely transfer session data
 */
@Injectable({ providedIn: 'root' })
export class SignupRedirectService {
  /**
   * Redirect user to PFWA with session data after successful signup
   * Creates a hidden POST form to securely transfer session information
   * 
   * @param pfwaSessionId - Unique session identifier for PFWA
   * @param pfwaSessionInfo - Session data to be transferred to PFWA
   */
  redirectToPfwa(pfwaSessionId: string, pfwaSessionInfo: string) {
    const location = `${environment.pfwaURL}?sessionId=${encodeURIComponent(pfwaSessionId)}`;

    const form = document.createElement('form');
    form.style.display = 'none';
    form.method = 'POST';
    form.action = location;

    const textarea = document.createElement('textarea');
    textarea.name = 'signupPfwaBody';
    textarea.value = pfwaSessionInfo;

    form.appendChild(textarea);
    document.body.appendChild(form);
    form.submit();
  }
}
